import { render, staticRenderFns } from "./Slogan.vue?vue&type=template&id=4e5a311d&scoped=true"
import script from "./Slogan.vue?vue&type=script&lang=js"
export * from "./Slogan.vue?vue&type=script&lang=js"
import style0 from "./Slogan.vue?vue&type=style&index=0&id=4e5a311d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5a311d",
  null
  
)

export default component.exports